import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

import { ForgotPasswordLayout } from '@thinknet-gmbh/platform-common-ui';
import { PlatformModulesEnum } from '@thinknet-gmbh/platform-common';

import { useAuthAxiosInstance } from 'src/pages/auth/auth.axios.instance/';
import { SUB_ROUTES } from 'src/components/app/app-routes.constants';

const ForgotPassword: React.FC = () => {
  const [isResetStage, setIsResetStage] = useState(true);
  const { forgotPassword } = useAuthAxiosInstance({ onFinish: () => setIsResetStage(false) });
  const navigate = useNavigate();
  const { t } = useTranslation(['auth', 'common']);

  return (
    <ForgotPasswordLayout
      t={t}
      navigate={() => navigate(SUB_ROUTES.authVerification)}
      forgotPassword={forgotPassword}
      module={PlatformModulesEnum.YUU_HR_MODULE}
      isResetStage={isResetStage}
    />
  );
};

export default ForgotPassword;
